import React from 'react'

export const Switch = ({ name, label, checked = false, onChange }) => {
  return (
    <div className="form-switch">
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id={name}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label className="form-label m-0" htmlFor={name}>
        {label}
      </label>
    </div>
  )
}
